export const photos=['/teamPhotos/fulano2 copy.jpg','/teamPhotos/fulano2.jpg','/teamPhotos/fulano3.png','/teamPhotos/teste.jpg']; export default photos;